export default __webpack_public_path__ + "static/media/people-in-front-of-laptop.87995631.svg";